import React from 'react';
import styles from './styles.module.scss';
import classNames from 'classnames';
import icClock from 'assets/img/ic_clock_2.png';
import icThg from 'assets/img/thetan_gem_V2.png';
import { formatCurrency } from '@wolffun/system-currency';
import { useVestingModal } from '../../VestingSafeModalProvider';
import { ModalName } from '../../VestingSafeModalProvider/config';
import { fetchClaimVestingSafe, fetchVestingSafeRemainingClaim } from '../../../redux/actions';
import { useTypedDispatch, useTypedSelector } from '../../../redux/utils';
import Button_V2 from '@vestingSafe/src/Components/Button_V2';
import { countDownToUTC00 } from '../../utils';
import { AppError } from '../../../redux/types';
import { useUserWalletContext } from '@profile/src/Profile_V2/UserWalletProvider';
import { navigateTo } from '@wolffun/app-manager/src/utils/navigate';

const ClaimBlock = ({
  claimableAmount,
  secondClaimFee,
  remainingInPool,
  isSmallerThanMin,
  fee
}) => {
  const {
    checkWalletError
  } = useUserWalletContext();
  const dispatch = useTypedDispatch();
  const remainingClaimCount = useTypedSelector(state => state.vestingSafeRemainingClaimCount.data);
  const {
    loading
  } = useTypedSelector(state => state.claimVestingSafe);
  const {
    openModal
  } = useVestingModal();
  const [nextClaimTime, setNextClaimTime] = React.useState(countDownToUTC00());
  const emptyPool = remainingInPool === 0;
  const noClaimTurnLeft = !remainingClaimCount || remainingClaimCount === 0;
  const hasExtraVesting = remainingClaimCount === 1;
  React.useEffect(() => {
    dispatch(fetchVestingSafeRemainingClaim());
  }, []);
  React.useEffect(() => {
    const interval = setInterval(() => {
      if (countDownToUTC00().asMinutes() > nextClaimTime.asMinutes()) {
        dispatch(fetchVestingSafeRemainingClaim());
      }

      setNextClaimTime(countDownToUTC00());
    }, 1000);
    return () => clearInterval(interval);
  });

  const onFreeClaimClick = async () => {
    const {
      data,
      error
    } = await dispatch(fetchClaimVestingSafe());

    if (error !== undefined && error !== AppError.NO_ERROR) {
      openModal(ModalName.ERROR, {
        error
      });
      return;
    }

    openModal(ModalName.DETAIL, {
      claimAmount: data
    });
    dispatch(fetchVestingSafeRemainingClaim()); // Check how many claimable times left
  };

  const historyClick = () => {
    if (checkWalletError()) {
      return;
    }

    navigateTo({
      pathname: '/profile',
      search: 'tab=history&category=vesting-safe-history'
    });
  };

  const renderClaimButtons = () => {
    if (emptyPool) {
      return /*#__PURE__*/React.createElement("div", {
        className: styles.claimGroup
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.buttonGroup
      }, /*#__PURE__*/React.createElement(Button_V2, {
        title: /*#__PURE__*/React.createElement("span", {
          className: styles.historyBtnTitle
        }, "History"),
        type: "secondary",
        className: classNames(styles.button, styles.historyButton),
        onClick: () => historyClick()
      }), /*#__PURE__*/React.createElement(Button_V2, {
        className: classNames(classNames(styles.button, styles.buttonGrow)),
        disabled: true,
        title: /*#__PURE__*/React.createElement("div", {
          className: styles.safeEmptyButton
        }, /*#__PURE__*/React.createElement("div", {
          className: styles.bigText
        }, /*#__PURE__*/React.createElement("span", null, "SAFE IS EMPTY")), /*#__PURE__*/React.createElement("div", {
          className: styles.smallText
        }, /*#__PURE__*/React.createElement("span", null, "FILL TO CLAIM THG")))
      })));
    }

    if (noClaimTurnLeft) {
      return /*#__PURE__*/React.createElement("div", {
        className: styles.claimGroup
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.buttonGroup
      }, /*#__PURE__*/React.createElement(Button_V2, {
        title: /*#__PURE__*/React.createElement("span", {
          className: styles.historyBtnTitle
        }, "History"),
        type: "secondary",
        className: classNames(styles.button, styles.historyButton),
        onClick: () => historyClick()
      }), /*#__PURE__*/React.createElement(Button_V2, {
        className: classNames(classNames(styles.button, styles.buttonGrow)),
        disabled: true,
        title: "Claimed"
      })));
    }

    if (isSmallerThanMin) {
      return /*#__PURE__*/React.createElement("div", {
        className: styles.claimGroup
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.buttonGroup
      }, /*#__PURE__*/React.createElement(Button_V2, {
        title: /*#__PURE__*/React.createElement("span", {
          className: styles.historyBtnTitle
        }, "History"),
        type: "secondary",
        className: classNames(styles.button, styles.historyButton),
        onClick: () => historyClick()
      }), /*#__PURE__*/React.createElement(Button_V2, {
        className: classNames(classNames(styles.button, styles.buttonGrow)),
        disabled: true,
        title: "Claim"
      })));
    }

    if (hasExtraVesting) {
      return /*#__PURE__*/React.createElement("div", {
        className: styles.claimGroup
      }, /*#__PURE__*/React.createElement(Button_V2, {
        className: classNames(styles.button),
        disabled: true,
        title: "Claimed"
      }), /*#__PURE__*/React.createElement("div", {
        className: styles.buttonGroup
      }, /*#__PURE__*/React.createElement(Button_V2, {
        title: /*#__PURE__*/React.createElement("span", {
          className: styles.historyBtnTitle
        }, "History"),
        type: "secondary",
        className: classNames(styles.button, styles.historyButton),
        onClick: () => historyClick()
      }), /*#__PURE__*/React.createElement(Button_V2, {
        type: "warning",
        loading: loading,
        className: classNames(classNames(styles.button, styles.buttonGrow)),
        onClick: () => openModal(ModalName.EXTRA_CLAIM, {
          feePercentage: secondClaimFee,
          claimAmount: claimableAmount,
          feeAmount: fee
        }),
        title: /*#__PURE__*/React.createElement("div", {
          className: styles.claimButton
        }, /*#__PURE__*/React.createElement("span", null, "Claim"), /*#__PURE__*/React.createElement("img", {
          src: icThg,
          alt: ""
        }), /*#__PURE__*/React.createElement("span", {
          className: styles.value
        }, claimableAmount ? formatCurrency(claimableAmount, {
          withCurrency: true,
          precision: 2
        }) : '-----'), /*#__PURE__*/React.createElement("div", {
          className: styles.fee
        }, /*#__PURE__*/React.createElement("span", null, secondClaimFee, "% Fee")))
      })));
    }

    return /*#__PURE__*/React.createElement("div", {
      className: styles.claimGroup
    }, /*#__PURE__*/React.createElement("div", {
      className: styles.buttonGroup
    }, /*#__PURE__*/React.createElement(Button_V2, {
      title: /*#__PURE__*/React.createElement("span", {
        className: styles.historyBtnTitle
      }, "History"),
      type: "secondary",
      className: classNames(styles.button, styles.historyButton),
      onClick: () => historyClick()
    }), /*#__PURE__*/React.createElement(Button_V2, {
      type: "warning",
      loading: loading,
      className: classNames(classNames(styles.button, styles.buttonGrow)),
      onClick: onFreeClaimClick,
      title: /*#__PURE__*/React.createElement("div", {
        className: styles.claimButton
      }, /*#__PURE__*/React.createElement("span", null, "Claim"), /*#__PURE__*/React.createElement("img", {
        src: icThg,
        alt: ""
      }), /*#__PURE__*/React.createElement("span", {
        className: styles.value
      }, claimableAmount ? formatCurrency(claimableAmount, {
        withCurrency: true,
        precision: 2
      }) : '-----'))
    })));
  };

  return /*#__PURE__*/React.createElement("div", {
    className: styles.claimBlock
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.nextClaim
  }, /*#__PURE__*/React.createElement("img", {
    src: icClock,
    alt: ""
  }), /*#__PURE__*/React.createElement("span", null, "Next claim in\xA0"), /*#__PURE__*/React.createElement("span", {
    className: styles.time
  }, `${nextClaimTime.hours()}h ${nextClaimTime.minutes()}m`)), /*#__PURE__*/React.createElement("div", {
    className: styles.buttonGroup
  }, renderClaimButtons()));
};

export default ClaimBlock;